import { listSimpleDictDatas } from '@/api/dict';
var state = {
  /**
   * 数据字典 MAP
   * key：数据字典大类枚举值 dictType
   * dictValue：数据字典小类数值 {dictValue: '', dictLabel: ''} 的数组
   */
  dictDatas: {}
};
var mutations = {
  SET_DICT_DATAS: function SET_DICT_DATAS(state, dictDatas) {
    state.dictDatas = dictDatas;
  }
};
var actions = {
  loadDictDatas: function loadDictDatas(_ref) {
    var commit = _ref.commit;
    listSimpleDictDatas().then(function (response) {
      // 如果未加载到数据，则直接返回
      if (!response) {
        return;
      }
      // 设置数据
      var dictDataMap = {};
      response.forEach(function (dictData) {
        // 获得 dictType 层级
        var enumValueObj = dictDataMap[dictData.dictType];
        if (!enumValueObj) {
          dictDataMap[dictData.dictType] = [];
        }
        // 处理 dictValue 层级
        dictDataMap[dictData.dictType].push({
          value: dictData.value,
          label: dictData.label,
          colorType: dictData.colorType,
          cssClass: dictData.cssClass
        });
      });
      // 存储到 Store 中
      commit('SET_DICT_DATAS', dictDataMap);
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};